<script lang="ts">
  import { Col, Input } from "sveltestrap";
  import { Featured, HighestPrices, LowestPrices, ShowingProducts } from "../../../../utils/Constant/Constant";

</script>
<Col md="9" sm="10" class="text-end">
    <span class="f-w-600 m-r-5">{ShowingProducts}</span>
    <div class="select2-drpdwn-product select-options d-inline-block" >
        <Input type="select" name="select" id="exampleSelect" class="btn-square" value="Featured">
            <option >{Featured}</option>
            <option >{LowestPrices}</option>
            <option >{HighestPrices}</option>
        </Input>
    </div>
</Col>